import React from 'react';
import { Button } from '@mui/material';
var LoadingButton = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.sx, sx = _c === void 0 ? {} : _c;
    return (React.createElement(Button, { variant: "contained", color: "primary", disabled: true, className: "lfc-bg-gray-200 ".concat(className), sx: sx }, "Loading..."));
};
export default LoadingButton;
//# sourceMappingURL=LoadingButton.js.map